<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
    <slot />
    <path
      :fill="color"
      d="M17.34 1.978L16.023.659C15.583.22 15.007 0 14.432 0c-.577 0-1.152.22-1.592.659L.452 13.047l-.447 4.016c-.056.505.342.937.837.937.031 0 .063-.002.095-.005l4.012-.444L17.341 5.16c.879-.879.879-2.304 0-3.182zM4.434 16.477l-3.27.362.364-3.275 9.277-9.277 2.91 2.91-9.281 9.28zM16.546 4.364l-2.037 2.037-2.91-2.91 2.037-2.037c.212-.212.495-.329.795-.329.3 0 .583.117.796.33l1.319 1.318c.438.439.438 1.153 0 1.591z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
